
<script setup>
import DataGrid from "@/components/common/other/DataGrid";
import Button from "@/components/common/input/Button"
import {inject} from 'vue';
import {useStore} from 'vuex';

const shipments = inject("shipments");
const store = useStore();

function openTracking(url) {

  window.open(url);
}

</script>

<template class="cmp-customs">

  <DataGrid
      :key="shipments.viewShipment.customs.length"
      height="160"
      :selectable="false"
      :row-selection="false"
      :allow-grid-menu="false"
      :allowPagination="false"
      :columns="shipments.customs.gridColumns"
      :dataSource="shipments.viewShipment.customs">
  </DataGrid>

</template>

<style scoped>

</style>
